<template>
  <div class="terms-page">
    <iframe :src="termsUrl" class="terms-frame"></iframe>
  </div>
</template>

<script>
export default {
  name: "TermsPage",
  computed: {
    termsUrl() {
      return "https://khgas-api.billing.city/docs/service-terms";
    },
  },
};
</script>

<style scoped>
.terms-page {
  width: 100%;
  height: 100%;
  background: #05090e;
}

.terms-frame {
  width: 100%;
  height: calc(100vh - 55px);
  border: 0;
  display: block;
  background: #fff;
}
</style>
